export default __webpack_public_path__ + "static/media/corelogic-icon.dcafb25f.svg";